var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#DC2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.736 14.182L11.358 7.14H14.312L13.878 14.182H11.736ZM12.828 17.626C12.436 17.626 12.1186 17.5 11.876 17.248C11.6333 16.9867 11.512 16.674 11.512 16.31C11.512 15.946 11.6333 15.638 11.876 15.386C12.1186 15.1247 12.436 14.994 12.828 14.994C13.2013 14.994 13.514 15.1247 13.766 15.386C14.018 15.638 14.144 15.946 14.144 16.31C14.144 16.674 14.018 16.9867 13.766 17.248C13.514 17.5 13.2013 17.626 12.828 17.626Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.43a6f7c01d8df5b9574fe85cbb99907d.svg";
export { ForwardRef as ReactComponent };